import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";
import getSymbolFromCurrency from 'currency-symbol-map';
import {
  Truck,
  Lock,
  Trash,

} from "lucide-react";
import { useCart } from "../components/CartContext";
import data from "../Data.json";
import { jwtDecode } from "jwt-decode";
import axios from "axios";

import { useCurrency } from "../components/CurrencyContext";


const Checkout = () => {
  const navigate = useNavigate();
  const { cart, removeFromCart, clearCart } = useCart();

  const [loading, setLoading] = useState(false);
  const [showPaymentDetails, setShowPaymentDetails] = useState(false);
  const [selectedCurrency, setSelectedCurrency] = useState("SAR");
  const [conversionRate, setConversionRate] = useState(1);
  const { rate, currency } = useCurrency();
  const [isGuestCheckout, setIsGuestCheckout] = useState(false);

  const convertPrice = (price) => {
    const productPrice = parseFloat(price) || 0;
    const convertedPrice = productPrice * rate;
    return convertedPrice
  }
  const currencySymbol = currency === "SAR" ? "﷼" : getSymbolFromCurrency(currency) || currency;


  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phone: "",
    street: "",
    country: "",
    city: "",
    state: "",
    postal_code: "",
    shippingMethod: "standard",
    agreeToTerms: false,
    cardNumber: "",
    cardName: "",
    cardExpiry: "",
    cardCvc: "",
  });

  const [errors, setErrors] = useState({});

  // Function to decode JWT and get user ID
  const getUserIdFromToken = () => {
    const token = sessionStorage.getItem("token");
    if (!token) {
      toast.error("Please login to continue checkout");
      navigate("/login", { state: { returnUrl: "/checkout" } });
      return null;
    }

    try {
      const decodedToken = jwtDecode(token);
      return decodedToken.userId || decodedToken.id;
    } catch (error) {
      toast.error("Invalid token. Please login again.");
      navigate("/login", { state: { returnUrl: "/checkout" } });
      return null;
    }
  };


  useState(() => {
    const token = sessionStorage.getItem("token");
    if (!token) {
      setIsGuestCheckout(true);
    }
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });

    if (errors[name]) {
      setErrors({
        ...errors,
        [name]: "",
      });
    }
  };

  // const validateForm = () => {
  //   let newErrors = {};
  //   const requiredFields = ["country", "city", "state", " postal_code: "","];

  //   requiredFields.forEach((key) => {
  //     if (!formData[key]) {
  //       newErrors[key] = "This field is required";
  //     }
  //   });

  //   // Validate payment details if online payment is selected
  //   if (formData.shippingMethod === "online") {
  //     if (!formData.cardNumber) newErrors.cardNumber = "Card number is required";
  //     if (!formData.cardName) newErrors.cardName = "Card holder name is required";
  //     if (!formData.cardExpiry) newErrors.cardExpiry = "Expiry date is required";
  //     if (!formData.cardCvc) newErrors.cardCvc = "CVC is required";
  //   }

  //   setErrors(newErrors);
  //   return Object.keys(newErrors).length === 0;
  // };


  const validateForm = () => {
    let newErrors = {};
    const requiredFields = isGuestCheckout
      ? ["fullName", "email", "phone", "street", "country", "city", "state", "postal_code"]
      : ["country", "city", "state", "postal_code"];

    requiredFields.forEach((key) => {
      if (!formData[key]) {
        newErrors[key] = "This field is required";
      }
    });

    // Email validation for guest checkout
    if (isGuestCheckout && formData.email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(formData.email)) {
        newErrors.email = "Please enter a valid email address";
      }
    }

    if (formData.shippingMethod === "online") {
      if (!formData.cardNumber) newErrors.cardNumber = "Card number is required";
      if (!formData.cardName) newErrors.cardName = "Card holder name is required";
      if (!formData.cardExpiry) newErrors.cardExpiry = "Expiry date is required";
      if (!formData.cardCvc) newErrors.cardCvc = "CVC is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleRemoveItem = (id) => {
    removeFromCart(id)
    toast.success("Item removed from cart");
  };

  const cleanPrice = (price) => {
    if (!price) return 0;
    if (typeof price === "number") return price;
    return parseFloat(price.toString().replace(/[^0-9.]/g, "")) || 0;
  };

  const getUserDetailsFromToken = () => {
    const token = sessionStorage.getItem("token");
    if (!token) {
      return null;
    }

    try {
      const decodedToken = jwtDecode(token);

      return {
        userId: decodedToken?.userId || decodedToken?.id || null,
        email: decodedToken?.email || null,
        phone: decodedToken?.phone || null,
        firstname: decodedToken?.first_name || null,
        lastname: decodedToken?.last_name || null,
      };
    } catch (error) {
      console.error("Invalid token:", error);
      return null;
    }
  };

  const userDetails = getUserDetailsFromToken();

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   const token = sessionStorage.getItem("token");
  //   if (!token) {
  //     toast.error("Please login to continue checkout");
  //     setTimeout(() => {
  //       navigate("/login", { state: { returnUrl: "/checkout" } });
  //     }, 2000);
  //     return;
  //   }
  //   // Validate form
  //   if (!validateForm()) {
  //     toast.error("Please fill in all required fields");
  //     return;
  //   }

  //   // Check if cart is empty
  //   if (cart.length === 0) {
  //     toast.error("Your cart is empty!");
  //     return;
  //   }

  //   // Get user ID from token
  //   const userId = getUserIdFromToken();
  //   if (!userId) return;

  //   // Prepare products array
  //   const products = cart.map(item => ({
  //     product_id: item.product_id,
  //     quantity: item.quantity,
  //     price: cleanPrice(item.price),
  //     currency_code: 'PKR',
  //     units: {
  //       size: item.selectedSize || null,
  //     },
  //   }));

  //   // Calculate total quantity and price
  //   const totalQuantity = cart.reduce((sum, item) => sum + item.quantity, 0);
  //   const subtotalPrice = cart.reduce((sum, item) =>
  //     sum + (cleanPrice(item.price) * item.quantity), 0);
  //   const totalPrice = subtotalPrice + shippingCost;

  //   setLoading(true);

  //   try {
  //     // Get the token from session storage
  //     const token = sessionStorage.getItem("token");

  //     // Make API call to create order
  //     const response = await axios.post(
  //       `${process.env.REACT_APP_API_URI}/orders/create`,
  //       {
  //         user_id: userId,
  //         products: products,
  //         quantity: totalQuantity,
  //         total_price: totalPrice,
  //         currency_code: 'SAR',
  //         status: "Pending",
  //         payment_method: formData.shippingMethod === "online" ? "card" : "cash"
  //       },
  //       {
  //         headers: {
  //           'Authorization': `Bearer ${token}`,
  //           'Content-Type': 'application/json'
  //         }
  //       }
  //     );
  //     if (response.status === 201) {
  //       clearCart();
  //       navigate('/order-confirmation');
  //     } else {
  //       toast.error("Something went wrong. Please try again.");
  //     }
  //   } catch (error) {
  //     console.error('Order creation error:', error);
  //     toast.error(
  //       error.message ||
  //       "Something went wrong. Please try again."
  //     );
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const handleSubmit = async () => {
    setLoading(true);

    if (typeof window === 'undefined') return;

    // For guest checkout, we don't check for token
    if (!isGuestCheckout) {
      const token = sessionStorage.getItem("token");
      if (!token) {
        toast.error("Please login to continue checkout");
        setTimeout(() => {
          navigate("/login?returnUrl=/checkout");
        }, 2000);
        setLoading(false);
        return;
      }
    }

    if (!validateForm()) {
      toast.error("Please fill in all required fields");
      setLoading(false);
      return;
    }

    if (cart.length === 0) {
      toast.error("Your cart is empty!");
      setLoading(false);
      return;
    }

    const userId = isGuestCheckout ? null : getUserIdFromToken();
    if (!isGuestCheckout && !userId) {
      toast.error("Invalid user session.");
      setLoading(false);
      return;
    }

    const products = cart.map(item => ({
      product_id: item.product_id,
      quantity: item.quantity,
      price: cleanPrice(item.price),
      currency_code: 'PKR',
      units: {
        size: item.selectedSize || null,
      },
    }));


    console.log("is product", products);


    const totalQuantity = cart.reduce((sum, item) => sum + item.quantity, 0);
    const subtotalPrice = cart.reduce((sum, item) =>
      sum + (cleanPrice(item.price) * item.quantity), 0);
    const totalPrice = subtotalPrice + shippingCost;

    console.log("is product");


    try {

      const token = isGuestCheckout ? null : sessionStorage.getItem("token");

      const headers = token ? {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      } : {
        'Content-Type': 'application/json'
      };




      if (!isGuestCheckout) {
        const shippingData = {
          person_id: userId,
          full_name: userDetails?.firstname && userDetails?.lastname
            ? `${userDetails.firstname} ${userDetails.lastname}`
            : formData.fullName,
          email: userDetails?.email || formData.email,
          phone: userDetails?.phone || formData.phone,
          street: formData.street,
          country: formData.country,
          city: formData.city,
          state: formData.state,
          postal_code: formData.postal_code,
        };

        // console.log("shippingData", shippingData);

        const ShippingResponse = await axios.post(
          `${process.env.REACT_APP_API_URI}/person-details/create`,
          shippingData,
          { headers }
        );



        if (ShippingResponse.status !== 201) {
          toast.error("Failed to save shipping details. Please try again.");
          setLoading(false);
          return;
        }

        const shippingDetailsID = ShippingResponse.data.shipping_details_id;

        console.log(ShippingResponse.data);
        console.log("shippingDetailsID", shippingDetailsID);
        const orderData = {
          user_id: userId,
          products,
          quantity: totalQuantity,
          total_price: totalPrice,
          currency_code: 'PKR',
          status: "Pending",
          payment_method: formData.shippingMethod === "online" ? "card" : "cash",
          shippingDetailsID: shippingDetailsID
        };

        const response = await axios.post(
          `${process.env.REACT_APP_API_URI}/orders/create`,
          orderData,
          { headers }
        );

        if (response.status === 201) {
          clearCart();
          navigate('/order-confirmation');
          toast.success("Order placed successfully!");
        } else {
          toast.error("Something went wrong. Please try again.");
        }

      } else if (isGuestCheckout) {
        const gustOrderData = {
          email: formData.email,
          companyid: 65,
          shipping: {
            full_name: formData.fullName,
            street: formData.street,
            city: formData.city,
            state: formData.state,
            postal_code: formData.postal_code,
            country: formData.country,
            phone: formData.phone,
          },
          products,
          totals: {
            quantity: totalQuantity,
            total_price: totalPrice,
            currency_code: 'PKR',
          },
        }

        console.log("gustOrderData", gustOrderData);
        const response = await axios.post(
          `${process.env.REACT_APP_API_URI}/guest/checkout`,
          gustOrderData,
        );

        if (response.status === 201) {
          clearCart();
          navigate('/order-confirmation');
          toast.success("Order placed successfully!");
        } else {
          toast.error("Something went wrong. Please try again.");
        }

        setLoading(false);
        sessionStorage.setItem('guestOrderToken', response.data.jwt_token);
      }
    } catch (error) {
      console.error('Order creation error:', error);
      console.log("Error response data:", error.response?.data);

      const errorMessage = error.response?.data?.error || "";

      if (errorMessage.includes("Insufficient inventory")) {
        toast.error("Sorry! This product is currently out of stock.", {
          duration: 4000,
        });
      } else {
        toast.error(error?.response?.data?.message || "Something went wrong.");
      }
    } finally {
      setLoading(false);
    }
  };


  const subtotal = cart.reduce((acc, item) => {
    const price = cleanPrice(item.price);
    const quantity = item.quantity || 1;
    return acc + (price * quantity);
  }, 0);

  const shippingCost = 5; // Standard shipping cost
  const totalPrice = subtotal + shippingCost;

  const shippingOptions = [
    {
      id: "standard",
      name: "Cash on delivery",
      price: 5,
      icon: Truck,
      days: "3-5",
    }
  ];

  const handlePaymentMethodChange = (method) => {
    setFormData({
      ...formData,
      shippingMethod: method
    });
    setShowPaymentDetails(method === "online");
  };

  const handleCurrencyChange = (currency, rate) => {
    setSelectedCurrency(currency);
    setConversionRate(rate);
  };

  const handleLoginRedirect = () => {
    navigate("/login?returnUrl=/checkout");
  };


  return (
    <div className="mt-[6rem] min-h-screen bg-gradient-to-b from-gray-50 to-gray-100 pt-[3rem]">
      <div className="max-w-7xl mx-auto px-4 py-8">
        <Toaster position="top-center" reverseOrder={false} />

        <div className="flex flex-col lg:flex-row gap-8">
          <div className="w-full lg:w-2/3 space-y-8">
            <div className="bg-white p-8 rounded-xl shadow-lg border border-gray-100">
              {/* <h2 className="text-2xl font-bold text-gray-800 mb-6">
                Shipping Information
              </h2> */}

              {isGuestCheckout ? (
                <>
                  <div className="flex justify-between items-center mb-6">
                    <h2 className="text-2xl font-bold text-gray-900">Guest Checkout</h2>
                    <button
                      onClick={handleLoginRedirect}
                      className="text-sm text-blue-600 hover:text-blue-800 hover:underline"
                    >
                      Already have an account? Login
                    </button>
                  </div>

                  <div className="space-y-6">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          Full Name *
                        </label>
                        <input
                          name="fullName"
                          value={formData.fullName}
                          onChange={handleChange}
                          className={`w-full px-4 py-3 border ${errors.fullName ? "border-red-500" : "border-gray-300"} rounded-lg focus:ring-2 focus:ring-black focus:border-transparent`}
                          placeholder="John Doe"
                        />
                        {errors.fullName && (
                          <p className="text-red-500 text-xs mt-1">{errors.fullName}</p>
                        )}
                      </div>

                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          Email *
                        </label>
                        <input
                          name="email"
                          type="email"
                          value={formData.email}
                          onChange={handleChange}
                          className={`w-full px-4 py-3 border ${errors.email ? "border-red-500" : "border-gray-300"} rounded-lg focus:ring-2 focus:ring-black focus:border-transparent`}
                          placeholder="john@example.com"
                        />
                        {errors.email && (
                          <p className="text-red-500 text-xs mt-1">{errors.email}</p>
                        )}
                      </div>

                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          Phone *
                        </label>
                        <input
                          name="phone"
                          value={formData.phone}
                          onChange={handleChange}
                          className={`w-full px-4 py-3 border ${errors.phone ? "border-red-500" : "border-gray-300"} rounded-lg focus:ring-2 focus:ring-black focus:border-transparent`}
                          placeholder="+1234567890"
                        />
                        {errors.phone && (
                          <p className="text-red-500 text-xs mt-1">{errors.phone}</p>
                        )}
                      </div>

                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          Street Address *
                        </label>
                        <input
                          name="street"
                          value={formData.street}
                          onChange={handleChange}
                          className={`w-full px-4 py-3 border ${errors.street ? "border-red-500" : "border-gray-300"} rounded-lg focus:ring-2 focus:ring-black focus:border-transparent`}
                          placeholder="123 Main St"
                        />
                        {errors.street && (
                          <p className="text-red-500 text-xs mt-1">{errors.street}</p>
                        )}
                      </div>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          Country *
                        </label>
                        <select
                          name="country"
                          value={formData.country}
                          onChange={handleChange}
                          className={`w-full px-4 py-3 border ${errors.country ? "border-red-500" : "border-gray-300"} rounded-lg focus:ring-2 focus:ring-black focus:border-transparent`}
                        >
                          <option value="">Select Country</option>
                          <option value="US">United States</option>
                          <option value="CA">Canada</option>
                          <option value="UK">United Kingdom</option>
                          <option value="AU">Australia</option>
                          <option value="IN">India</option>
                          <option value="PK">Pakistan</option>
                        </select>
                        {errors.country && (
                          <p className="text-red-500 text-xs mt-1">{errors.country}</p>
                        )}
                      </div>

                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          City *
                        </label>
                        <input
                          name="city"
                          value={formData.city}
                          onChange={handleChange}
                          className={`w-full px-4 py-3 border ${errors.city ? "border-red-500" : "border-gray-300"} rounded-lg focus:ring-2 focus:ring-black focus:border-transparent`}
                          placeholder="New York"
                        />
                        {errors.city && (
                          <p className="text-red-500 text-xs mt-1">{errors.city}</p>
                        )}
                      </div>

                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          State/Province *
                        </label>
                        <input
                          name="state"
                          value={formData.state}
                          onChange={handleChange}
                          className={`w-full px-4 py-3 border ${errors.state ? "border-red-500" : "border-gray-300"} rounded-lg focus:ring-2 focus:ring-black focus:border-transparent`}
                          placeholder="NY"
                        />
                        {errors.state && (
                          <p className="text-red-500 text-xs mt-1">{errors.state}</p>
                        )}
                      </div>

                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          Postal Code *
                        </label>
                        <input
                          name="postal_code"
                          value={formData.postal_code}
                          onChange={handleChange}
                          className={`w-full px-4 py-3 border ${errors.postal_code ? "border-red-500" : "border-gray-300"} rounded-lg focus:ring-2 focus:ring-black focus:border-transparent`}
                          placeholder="10001"
                        />
                        {errors.postal_code && (
                          <p className="text-red-500 text-xs mt-1">{errors.postal_code}</p>
                        )}
                      </div>
                      <div>

                        <div className="flex items-start gap-2 mt-1">
                          <input
                            type="checkbox"
                            id="smsConsent"
                            required
                            className="mt-1 w-4 h-4 accent-[#f36812] cursor-pointer flex-shrink-0"
                          />
                          <label htmlFor="smsConsent" className="text-gray-600 text-xs">
                            I agree to receive SMS text messages from VitalSource Wholesale LLC, including delivery notifications and order updates. Message & data rates may apply. Reply STOP to opt out at any time. View our{" "}
                            <Link
                              to="/privacy-policy"
                              className="text-[#f36812] hover:text-[#d95700] font-medium"
                            >
                              Privacy Policy
                            </Link>
                          </label>
                        </div>

                      </div>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <h2 className="text-2xl font-bold text-gray-900 mb-6">Shipping Information</h2>
                  <div className="space-y-6">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          Country
                        </label>
                        <select
                          name="country"
                          value={formData.country}
                          onChange={handleChange}
                          className={`w-full px-4 py-3 border ${errors.country ? "border-red-500" : "border-gray-300"} rounded-lg focus:ring-2 focus:ring-black focus:border-transparent`}
                        >
                          <option value="">Select Country</option>
                          <option value="US">United States</option>
                          <option value="CA">Canada</option>
                          <option value="UK">United Kingdom</option>
                          <option value="AU">Australia</option>
                          <option value="IN">India</option>
                          <option value="PK">Pakistan</option>
                        </select>
                        {errors.country && (
                          <p className="text-red-500 text-xs mt-1">{errors.country}</p>
                        )}
                      </div>

                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          City
                        </label>
                        <input
                          name="city"
                          value={formData.city}
                          onChange={handleChange}
                          className={`w-full px-4 py-3 border ${errors.city ? "border-red-500" : "border-gray-300"} rounded-lg focus:ring-2 focus:ring-black focus:border-transparent`}
                          placeholder="New York"
                        />
                        {errors.city && (
                          <p className="text-red-500 text-xs mt-1">{errors.city}</p>
                        )}
                      </div>

                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          State/Province
                        </label>
                        <input
                          name="state"
                          value={formData.state}
                          onChange={handleChange}
                          className={`w-full px-4 py-3 border ${errors.state ? "border-red-500" : "border-gray-300"} rounded-lg focus:ring-2 focus:ring-black focus:border-transparent`}
                          placeholder="NY"
                        />
                        {errors.state && (
                          <p className="text-red-500 text-xs mt-1">{errors.state}</p>
                        )}
                      </div>


                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          Street
                        </label>
                        <input
                          name="street"
                          value={formData.street}
                          onChange={handleChange}
                          className={`w-full px-4 py-3 border ${errors.street ? "border-red-500" : "border-gray-300"} rounded-lg focus:ring-2 focus:ring-black focus:border-transparent`}
                          placeholder="NY"
                        />
                        {errors.street && (
                          <p className="text-red-500 text-xs mt-1">{errors.street}</p>
                        )}
                      </div>

                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          postal_code: "",/Postal Code
                        </label>
                        <input
                          name="postal_code"
                          value={formData.postal_code}
                          onChange={handleChange}
                          className={`w-full px-4 py-3 border ${errors.postal_code ? "border-red-500" : "border-gray-300"} rounded-lg focus:ring-2 focus:ring-black focus:border-transparent`}
                          placeholder="10001"
                        />
                        {errors.postal_code && (
                          <p className="text-red-500 text-xs mt-1">{errors.postal_code}</p>
                        )}
                      </div>
                    </div>
                  </div>
                </>
              )}

              <div className="mt-8">
                <h3 className="text-lg font-semibold text-gray-900 mb-4">
                  Payment Method
                </h3>

                <div className="space-y-3">
                  {shippingOptions.map((option) => {
                    const ShippingIcon = option.icon;
                    return (
                      <label
                        key={option.id}
                        className={`block w-full p-4 border ${formData.shippingMethod === option.id
                          ? "border-[#f36812] bg-gray-50"
                          : "border-gray-200"
                          } rounded-lg cursor-pointer transition-all hover:border-black`}
                      >
                        <div className="flex items-center">
                          <input
                            type="radio"
                            name="shippingMethod"
                            value={option.id}
                            checked={formData.shippingMethod === option.id}
                            onChange={() => handlePaymentMethodChange(option.id)}
                            className="h-4 w-4 text-black focus:ring-black"
                          />
                          <div className="ml-4 flex items-center flex-1">
                            <div
                              className={`p-2 rounded-full ${formData.shippingMethod === option.id
                                ? "bg-[#f36812] text-white"
                                : "bg-[#f36812] text-gray-500"
                                }`}
                            >
                              <ShippingIcon size={20} />
                            </div>
                            <div className="ml-3">
                              <p className="font-medium text-gray-900">
                                {option.name}
                              </p>
                              <p className="text-sm text-gray-500">
                                Delivery in {option.days} days
                              </p>
                            </div>
                            <div className="ml-auto font-semibold text-gray-900">
                              {option.price === 0
                                ? "Free"
                                : `Rs. ${option.price.toFixed(2)}`}
                            </div>
                          </div>
                        </div>
                      </label>
                    );
                  })}
                </div>

                {showPaymentDetails && (
                  <div
                    className="mt-6 p-6 bg-gray-50 rounded-lg border border-gray-200"

                  >
                    <h4 className="text-lg font-semibold text-gray-900 mb-4">
                      Card Details
                    </h4>
                    <div className="space-y-4">
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          Card Number
                        </label>
                        <input
                          type="text"
                          name="cardNumber"
                          value={formData.cardNumber}
                          onChange={handleChange}
                          placeholder="1234 5678 9012 3456"
                          className={`w-full px-4 py-3 border ${errors.cardNumber ? "border-red-500" : "border-gray-300"} rounded-lg focus:ring-2 focus:ring-black focus:border-transparent`}
                        />
                        {errors.cardNumber && (
                          <p className="text-red-500 text-xs mt-1">{errors.cardNumber}</p>
                        )}
                      </div>

                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          Name on Card
                        </label>
                        <input
                          type="text"
                          name="cardName"
                          value={formData.cardName}
                          onChange={handleChange}
                          placeholder="John Doe"
                          className={`w-full px-4 py-3 border ${errors.cardName ? "border-red-500" : "border-gray-300"} rounded-lg focus:ring-2 focus:ring-black focus:border-transparent`}
                        />
                        {errors.cardName && (
                          <p className="text-red-500 text-xs mt-1">{errors.cardName}</p>
                        )}
                      </div>

                      <div className="grid grid-cols-2 gap-4">
                        <div>
                          <label className="block text-sm font-medium text-gray-700 mb-1">
                            Expiry Date
                          </label>
                          <input
                            type="text"
                            name="cardExpiry"
                            value={formData.cardExpiry}
                            onChange={handleChange}
                            placeholder="MM/YY"
                            className={`w-full px-4 py-3 border ${errors.cardExpiry ? "border-red-500" : "border-gray-300"} rounded-lg focus:ring-2 focus:ring-black focus:border-transparent`}
                          />
                          {errors.cardExpiry && (
                            <p className="text-red-500 text-xs mt-1">{errors.cardExpiry}</p>
                          )}
                        </div>

                        <div>
                          <label className="block text-sm font-medium text-gray-700 mb-1">
                            CVC
                          </label>
                          <input
                            type="text"
                            name="cardCvc"
                            value={formData.cardCvc}
                            onChange={handleChange}
                            placeholder="123"
                            className={`w-full px-4 py-3 border ${errors.cardCvc ? "border-red-500" : "border-gray-300"} rounded-lg focus:ring-2 focus:ring-black focus:border-transparent`}
                          />
                          {errors.cardCvc && (
                            <p className="text-red-500 text-xs mt-1">{errors.cardCvc}</p>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>



          <div className="w-full lg:w-1/3 space-y-6">
            <div className="bg-white p-6 rounded-xl shadow-lg border border-gray-100 sticky top-24">
              <h3 className="text-xl font-bold text-gray-800 mb-4 pb-4 border-b border-gray-100">
                Order Summary
              </h3>

              {cart.length > 0 ? (
                <div className="space-y-4 mb-6 max-h-80 overflow-y-auto pr-2">
                  {cart.map((item, index) => (
                    <div
                      key={index}
                      className="flex items-center space-x-4 pb-4 border-b border-gray-100 last:border-0"
                    >
                      <div className="flex-shrink-0 w-16 h-16 bg-gray-100 rounded-lg overflow-hidden">
                        <img
                          src={`${process.env.REACT_APP_API_URI}/uploads/${item.image}` || data.products[0].image}
                          alt={item.product_name}
                          className="w-full h-full object-cover"
                        />
                      </div>

                      <div className="flex-1 min-w-0">
                        <h4 className="text-sm font-semibold text-gray-800 truncate">
                          {item.product_name}
                        </h4>
                        <h3 className="font-medium text-gray-900">
                          {item.name || item.selectedSize}
                        </h3>
                        <p className="text-sm text-gray-500">Quantity: {item.quantity}</p>
                      </div>

                      <div className="flex flex-col items-end">
                        <span className="text-gray-800 font-medium">
                          {currencySymbol} {cleanPrice(convertPrice(item.price).toFixed(2)).toFixed(2)}
                        </span>
                        <button
                          type="button"
                          onClick={() => handleRemoveItem(item.product_id)}
                          className="text-gray-400 hover:text-red-500 mt-1 p-1"
                        >
                          <Trash size={16} />
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="py-8 text-center">
                  <p className="text-gray-500">Your cart is empty.</p>
                </div>
              )}

              {/* <CurrencyConverter
                subtotal={subtotal}
                shippingCost={shippingCost}
                totalPrice={totalPrice}
                onCurrencyChange={handleCurrencyChange}
              /> */}

              <div>
                <p className="text-gray-600 text-xs"><span className="font-bold">Note </span>: The actual payment will be processed in ( ﷼ ) SAR. This is only for reference.</p>
              </div>

              {cart.length > 0 && (
                <div className="space-y-3 pt-4 border-t border-gray-100">
                  <div className="flex justify-between text-gray-600">
                    <span>Subtotal</span>
                    <span>
                      {selectedCurrency === "SAR" ? (
                        <>{currencySymbol} {convertPrice(subtotal.toFixed(2)).toFixed(2)}</>
                      ) : (
                        <>
                          {getSymbolFromCurrency(selectedCurrency)} {(subtotal * conversionRate).toFixed(2)}
                          <span className="text-xs text-gray-500 block">
                            ({currencySymbol} {convertPrice(subtotal.toFixed(2)).toFixed(2)})
                          </span>
                        </>
                      )}
                    </span>
                  </div>

                  <div className="flex justify-between text-gray-600">
                    <span>Shipping</span>
                    <span>
                      {shippingCost === 0 ? (
                        "Free"
                      ) : selectedCurrency === "SAR" ? (
                        <>{currencySymbol} {convertPrice(shippingCost.toFixed(2)).toFixed(2)}</>
                      ) : (
                        <>
                          {currencySymbol} {(shippingCost * conversionRate).toFixed(2)}
                          <span className="text-xs text-gray-500 block">
                            ({currencySymbol} {convertPrice(shippingCost.toFixed(2)).toFixed(2)})
                          </span>
                        </>
                      )}
                    </span>
                  </div>

                  <div className="flex justify-between font-semibold text-lg pt-3 border-t border-gray-100">
                    <span>Total</span>
                    <span className="text-[#f36812]">
                      {selectedCurrency === "SAR" ? (
                        <>{currencySymbol} {convertPrice(totalPrice.toFixed(2)).toFixed(2)}</>
                      ) : (
                        <>
                          {currencySymbol} {(totalPrice * conversionRate).toFixed(2)}
                          <span className="text-xs text-gray-500 block">
                            ({currencySymbol} {convertPrice(totalPrice.toFixed(2)).toFixed(2)})
                          </span>
                        </>
                      )}
                    </span>
                  </div>
                </div>
              )}
              {cart.length > 0 && (
                <button
                  type="submit"
                  onClick={handleSubmit}
                  disabled={loading}
                  className={`w-full mt-6 px-6 py-3 bg-[#f36812] text-white rounded-lg hover:bg-orange-700 transition-colors flex items-center justify-center font-medium ${loading ? "opacity-70 cursor-not-allowed" : ""
                    }`}
                >
                  {loading ? (
                    <>Processing...</>
                  ) : (
                    <>
                      Complete Order <Lock size={18} className="ml-2" />
                    </>
                  )}
                </button>
              )}
              <div className="mt-6 flex items-center justify-center border-t border-gray-100 pt-4">
                <div className="bg-gray-50 rounded-lg p-3 flex items-center text-gray-500 text-sm">
                  <Lock size={16} className="mr-2" />
                  <span>Secure Checkout</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Checkout;